import Language from "@/domain/enums/Language";
import DisplayPreferences from "./DisplayPreferences";
import NotificationPreferences from "./NotificationPreferences";
import Theme from "./Theme";

type SettingsProps = {
    theme: Theme;
    displayPreferences: DisplayPreferences;
    preferredLanguage: Language;
    customSignature?: string;
    notificationPreferences: NotificationPreferences;
};

export default class Settings {
    theme: Theme;

    displayPreferences: DisplayPreferences;

    preferredLanguage: Language;

    customSignature?: string;

    notificationPreferences: NotificationPreferences;

    constructor({
        theme,
        displayPreferences,
        preferredLanguage,
        customSignature,
        notificationPreferences,
    }: SettingsProps) {
        this.theme = theme;
        this.displayPreferences = displayPreferences;
        this.preferredLanguage = preferredLanguage;
        this.customSignature = customSignature;
        this.notificationPreferences = notificationPreferences;
    }
}
